import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalProps } from '../modal.component';
import { ButtonVariant } from '@amobee/component-library';

@Component({
    selector: 'modal-footer-wrapper',
    templateUrl: './modal-footer-wrapper.component.html'
})
export class ModalFooterWrapperComponent implements OnInit {
    @Input() public footerContent: ModalProps['footerContent'];
    @Output() public close = new EventEmitter<any>();

    public defaultButton = {
        label: 'OK',
        variant: ButtonVariant.PRIMARY
    };

    constructor() { }

    ngOnInit() { }

    closeModal(onConfirm) {
        if (onConfirm) {
            onConfirm();
        }
        this.close.emit();
    }

}
